import React, { Suspense } from 'react'
const PerformanceVsMarketEmailLazy = React.lazy(() => import('../pages/PerformanceVsMarketEmail.page'))

export const performanceVsMarketEmail = [
  {
    path: 'performance-vs-market-email',

    element: (
      <Suspense fallback={<div></div>}>
        <PerformanceVsMarketEmailLazy />
      </Suspense>
    ),
  },
]
